import {VmView} from 'components'

export default function DefaultHeader() {
  return (
    <VmView className="w-full min-h-[3rem] h-full flex justify-center items-center text-center rounded-lg bg-red1-stripes">
      Header
    </VmView>
  )
}
